import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "ya-header"
};
const _hoisted_2 = {
  class: "ya-header-left"
};
const _hoisted_3 = {
  class: "ya-header-left-avatar"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "ya-header-left-info-nickname"
};
const _hoisted_6 = {
  class: "ya-header-left-info-text"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 1,
  class: "ya-header-left-info"
};
const _hoisted_9 = {
  class: "ya-header-left-info-nickname"
};
const _hoisted_10 = {
  class: "ya-header-left-info-text"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "ya-header-left-info-text-lint"
}, null, -1);
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "ya-header-right"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 0,
  class: "ya-header-right-tip-num"
};
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getNotificationInAppCategory } from '@/models/api/yourAccountApi.js';
import { Bridge } from '@/utils/bridge';
import { isLoginAuthenticated } from '@/utils/common';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { NOT_AUTHORIZE_LOGIN_PATH } from './../constants';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
const ROUTE_NAME = 'yoCustomerReview';
const ACCOUNT_SETTINGS_PAGE_ROUTER = 'accountSettings';
const MESSAGE_CENTER_PAGE_ROUTER = 'messageCenter';
export default {
  __name: 'YAHeader',
  props: {
    isLogin: Boolean,
    customerReviewCount: Object
  },
  emits: ['update:isLogin'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/yourAccount/components/YAHeader.less');
    const {
      IMAGE_URL
    } = constants;
    const {
      UNREAD_QUANTITY_RANGE,
      UNREAD_QUANTITY_RANGE_MARK,
      ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP,
      ENCRYPTED_MARKETPLACE_ID
    } = constants;
    const ROUTE_PARAMETER_ENUM = Object.freeze({
      // 0-To be evaluate 1-Evaluated
      TO_BE_EVALUATED: 0,
      EVALUATED: 1
    });
    const ICON_ENUM = {
      MY_AVATAR: constants.MY_AVATAR,
      NOTIFICATION_RING: `${IMAGE_URL}assets/svg/msgIcon.svg`,
      SETTING: `${IMAGE_URL}assets/svg/settingIcon.svg`,
      RIGHT_ARROW: `${IMAGE_URL}assets/image/mine-icon/right_regular.png`
    };
    const unreadMessageNumber = ref(0);
    const router = useRouter();
    const userName = ref('');
    const jumpToPage = async (path, reviewStatus) => {
      if (path === ACCOUNT_SETTINGS_PAGE_ROUTER) {
        awsRumHandler.recordClickEvent(clickEvents.yourAccountPage.goToSettingsButton);
      }
      if (!NOT_AUTHORIZE_LOGIN_PATH.includes(path)) {
        await isLoginAuthenticated();
        const isLoginStatus = await isLoginAuthenticated(false);
        emit('update:isLogin', isLoginStatus);
        if (!isLoginStatus) return;
      }
      if (path === ROUTE_NAME) {
        router.push({
          name: path,
          params: {
            reviewStatus
          }
        });
      } else {
        router.push({
          name: path
        });
      }
    };
    const getUnreadMessageQuantity = async () => {
      const {
        data
      } = await getNotificationInAppCategory({
        language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID]
      });
      unreadMessageNumber.value = (data === null || data === void 0 ? void 0 : data.unreadCount) || 0;
    };
    watch(() => props.isLogin, isLogin => {
      if (isLogin) {
        Bridge.callFn('getCurrentUserInfo', null, infor => {
          const {
            name
          } = infor;
          userName.value = name || '';
        });
        getUnreadMessageQuantity();
      }
    }, {
      immediate: true
    });
    const login = async () => {
      awsRumHandler.recordClickEvent(clickEvents.yourAccountPage.loginButton);
      await isLoginAuthenticated();
      emit('update:isLogin', await isLoginAuthenticated(false));
    };
    return (_ctx, _cache) => {
      var _props$customerRevie, _props$customerRevie2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: ICON_ENUM.MY_AVATAR,
        draggable: "false"
      }, null, 8, _hoisted_4)]), !__props.isLogin ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: login,
        class: "ya-header-left-info"
      }, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('modules.yourAccount.WELCOME_YOU')), 1), _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.$t('modules.yourAccount.LOGIN_AND_REGISTRATION')), 1), _createElementVNode("img", {
        src: ICON_ENUM.RIGHT_ARROW,
        class: "ya-header-left-info-text-icon",
        draggable: "false"
      }, null, 8, _hoisted_7)])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(userName.value), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", {
        onClick: _cache[0] || (_cache[0] = $event => jumpToPage(ROUTE_NAME, _unref(ROUTE_PARAMETER_ENUM).EVALUATED))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.yourAccount.COMMENTED')) + " ", 1), _withDirectives(_createElementVNode("span", null, _toDisplayString(__props.customerReviewCount.commmentedCount), 513), [[_vShow, (_props$customerRevie = __props.customerReviewCount) === null || _props$customerRevie === void 0 ? void 0 : _props$customerRevie.commmentedCount]])]), _hoisted_11, _createElementVNode("p", {
        onClick: _cache[1] || (_cache[1] = $event => jumpToPage(ROUTE_NAME, _unref(ROUTE_PARAMETER_ENUM).TO_BE_EVALUATED))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.yourAccount.TO_EVALUATE')) + " ", 1), _withDirectives(_createElementVNode("span", null, _toDisplayString(__props.customerReviewCount.toBeCommentedCount), 513), [[_vShow, (_props$customerRevie2 = __props.customerReviewCount) === null || _props$customerRevie2 === void 0 ? void 0 : _props$customerRevie2.toBeCommentedCount]])]), _createElementVNode("img", {
        src: ICON_ENUM.RIGHT_ARROW,
        class: "ya-header-left-info-text-icon",
        draggable: "false"
      }, null, 8, _hoisted_12)])]))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: "ya-header-right-tip",
        onClick: _cache[2] || (_cache[2] = $event => jumpToPage(ACCOUNT_SETTINGS_PAGE_ROUTER))
      }, [_createElementVNode("img", {
        src: ICON_ENUM.SETTING,
        draggable: "false"
      }, null, 8, _hoisted_14)]), _createElementVNode("div", {
        class: "ya-header-right-tip",
        onClick: _cache[3] || (_cache[3] = $event => jumpToPage(MESSAGE_CENTER_PAGE_ROUTER))
      }, [_createElementVNode("img", {
        src: ICON_ENUM.NOTIFICATION_RING,
        draggable: "false"
      }, null, 8, _hoisted_15), unreadMessageNumber.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(unreadMessageNumber.value > _unref(UNREAD_QUANTITY_RANGE) ? _unref(UNREAD_QUANTITY_RANGE_MARK) : unreadMessageNumber.value), 1)) : _createCommentVNode("", true)])])]);
    };
  }
};